import { render, staticRenderFns } from "./DataEmpty.vue?vue&type=template&id=3bd17b84&scoped=true"
import script from "./DataEmpty.vue?vue&type=script&lang=js"
export * from "./DataEmpty.vue?vue&type=script&lang=js"
import style0 from "./DataEmpty.vue?vue&type=style&index=0&id=3bd17b84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd17b84",
  null
  
)

export default component.exports